var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 22 3.5859375 L 17.478516 8.1074219 L 10.738281 10.035156 C 9.4172813 10.392156 8.3715 11.380547 7.9375 12.685547 L 3.859375 25.273438 L 5.2929688 26.707031 L 6.7265625 28.140625 L 19.320312 24.060547 C 20.618313 23.628547 21.606938 22.581437 21.960938 21.273438 L 23.888672 14.525391 L 28.414062 10 L 22 3.5859375 z M 22 6.4140625 L 25.585938 10 L 23 12.585938 L 19.414062 9 L 22 6.4140625 z M 17.710938 10.125 L 21.875 14.289062 L 20.033203 20.738281 C 19.851203 21.410281 19.349266 21.942156 18.697266 22.160156 L 7.6894531 25.724609 L 13.484375 19.929688 A 2 2 0 0 0 14 20 A 2 2 0 0 0 14 16 A 2 2 0 0 0 12.070312 18.515625 L 6.2753906 24.310547 L 9.8378906 13.310547 C 10.057891 12.649547 10.590391 12.148891 11.275391 11.962891 L 17.710938 10.125 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.23f584d6c1f7606d8c986d503cc86fd1.svg";
export { ForwardRef as ReactComponent };